import React, { useRef, useEffect, useLayoutEffect } from "react";
import classnames from "classnames";

import useWindowResize from "../../../../hooks/useWIndowResize";
import Icon from "../../../../components/Icon";
import useQuotePopup from "../../../../hooks/useQuotePopup";
import logoPacifico from '../../../../assets/images/header/logo-pacifico.png'

import "./styles.css";
import { QuotationForm } from "../../../home-insurance-quote";
import closeIcon from '../../../../assets/images/icons/close.svg';

const QuotePopup = () => {
    const { opened, closeQuotePopup, successLoadQuotePopup } = useQuotePopup();
    const { isMobile } = useWindowResize();
    const documentNumberRef = useRef();
    useEffect(() => {
        if (opened) {
            documentNumberRef.current && documentNumberRef.current.focus();
        }
        if (opened) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [opened, documentNumberRef]);
    useLayoutEffect(() => {
        successLoadQuotePopup();
    }, [successLoadQuotePopup]);
    return (
        <>
            <div
                className={classnames("quotePopup", {
                    "quotePopup--closed": !opened,
                    "quotePopup--opened": opened,
                    "quotePopup--desktop": !isMobile,
                })}
            >
                <div className="quotePopup__header">
                    <Icon
                        className="c-pointer quotePopup__header__close"
                        size={20}
                        name="close"
                        image={closeIcon}
                        onClick={() => closeQuotePopup()}
                    ></Icon>
                    <img
                        title="logo pacifico"
                        className="quotePopup__header__logo"
                        src={logoPacifico}
                        alt="pacifico logo"
                    />
                </div>
                <div className="quotePopup__content">
                    <QuotationForm></QuotationForm>
                </div>
            </div>
        </>
    );
};

export default QuotePopup;
